import React from 'react'
import { ROUTES } from '../../../config/routingUrl';
import { useNavigate } from 'react-router-dom';

const SectionAboutBarner = () => {
    const  navigate  =  useNavigate();
    return (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", padding: "200px 10px 350px 30px", background: "linear-gradient(90deg, #E1FFD5, #FFFFFF)", }} className="container-fluid ">
            <div className="container " style={{ width: "100%", }}>
                <div className="row">
                    <div className="col-md-6">
                        <div className="row">

                            <div className="col-md-12">
                                <div><h2 style={{ color: "#595959", fontSize: "56px" }}>À Propos de Mareza</h2></div>
                                <div>
                                    <p style={{ color: "#000000" }}>
                                        Nous avons de nombreux types de véhicules qui sont prêts
                                        à vous aidez n'importe où et n'importe quand.
                                    </p>
                                </div>
                                <div style={{ width: "100%", padding: "50px 0px 0px 0px" }}>
                                    <div>
                                        <button type="button" onClick={() => { navigate(`/${ROUTES.CAR_LIST_WEB}`) }} style={{ color: "#42B711", boxShadow: "0px 0px 2.5px #42B711", background: "white", border: "1.5px #42B711 solid", padding: "25px 30px 25px 30px", fontSize: "20px", fontWeight: "bold", borderRadius: "30px" }}>
                                            Explorer les offres
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-md-6">

                        <div style={{ position: "relative", marginTop:"80px" }} >
                            <div style={{ position: "absolute", zIndex: 50, right: "5%" }}> <img src="design/images/Property.png" /></div>
                            <div style={{ position: "absolute", zIndex: 55, top:30, right: "5%" }}><img src="design/images/Vector_design.png" /></div>
                            <div style={{ position: "absolute", zIndex: 60, top: 170, left:150, bottom:20,marginRight:"-60px", paddingLeft:"100px"}}><img src="design/images/Toyota_Camry_Home.png"  /></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SectionAboutBarner;
